
class SiteLicenseInvitation {
  constructor(data) {
    this.invitationId = data.invitationId
    this.organization = data.organization
    this.product = data.product
    this.subscription = data.subscription;
  }
}


export default SiteLicenseInvitation
